import axios from '@/axios.js'

export default {
  // getCashBookTemporary (context, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/api/v1/cashflow/${payload.companyID}/all`)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  getCashBookTemporary () {
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/cashflow-temporary')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findCashBookTemporary (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/cashflow-temporary/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createCashBookTemporary (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/cashflow-temporary', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCashBookTemporary (context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/v1/cashflow-temporary/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteCashBookTemporary (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v1/cashflow-temporary/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
